import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import { useEditSettingsLink } from "../../hooks/useEditSettingsLink";

export const PhoneNumberErrorMessage: React.FC = () => {
  return (
    <Typography color={Core.text.critical} variant="labelSansRegular">
      <StrictLocalMsg
        defaultMessage="Add a phone number in your <LinkFormatting>account settings</LinkFormatting>"
        description={{
          text: "Error message to inform the user that they need to enter a phone number.",
        }}
        values={{
          LinkFormatting: LinkToAccountSetting,
        }}
      />
    </Typography>
  );
};

const LinkToAccountSetting = (chunks: React.ReactNode) => {
  const editSettingsLink = useEditSettingsLink();
  return (
    <Button
      variant="tertiary"
      linkTo={editSettingsLink}
      style={{
        color: Core.text.critical,
        textDecorationColor: Core.text.critical,
        fontSize: "inherit",
      }}
      target="_blank"
    >
      {chunks}
    </Button>
  );
};
